import { takeLatest, put, all, call } from "redux-saga/effects";
import { MY_DELIVERIES_FETCHING } from "../reducers/actionTypes";

import { actions as deliveryActions } from "../reducers/myDeliveries";

import { getDailyDeliveries, getNextDeliveries } from "@services/api";

function* getDeliveries(action) {
  try {
    const myDeliveries = yield call(getDailyDeliveries);
    const nextDeliveries = yield call(getNextDeliveries);

    yield put(
      deliveryActions.myDeliveriesFetched({
        myDeliveries: myDeliveries.data,
        nextDeliveries: nextDeliveries.data,
      }),
    );
  } catch (err) {
    yield put(
      deliveryActions.myDeliveriesFetchFailed({
        myDeliveries: [],
        nextDeliveries: [],
      }),
    );
  }
}

export default function* root() {
  yield all([takeLatest(MY_DELIVERIES_FETCHING, getDeliveries)]);
}
